import { REQUIRED_DOCS, EXPIRY_DOCS, CRITICAL_FLAGS, today } from "./AuthKit";

export const riskVerdict = (f) => {
  if (f.red_flags.some((x) => CRITICAL_FLAGS.includes(x))) return "Failed";
  if (f.red_flags.length || (f.risk_score || 0) > 6) return "Passed with Notes";
  return f.risk_score ? "Passed" : "";
};

const fmcsa = (f) => {
  const m = f.fmcsa;
  if (m.operating_status !== "Authorized") return "Operating status must be Authorized.";
  if (!m.authority_date) return "Enter the authority grant date.";
  if (m.insurance_on_file !== true) return "Insurance must be on file with FMCSA.";
  if (!m.safety_rating) return "Select the safety rating.";
  if (m.safety_rating === "Unsatisfactory") return "An Unsatisfactory safety rating can't be approved.";
  return "";
};

const documents = (f) => {
  const usesFactoring = f.factoring.uses_factoring === true;
  if (f.factoring.uses_factoring == null) return "Choose whether the carrier uses factoring.";
  if (usesFactoring && !f.factoring.company.trim()) return "Enter the factoring company.";
  for (const d of REQUIRED_DOCS) {
    const r = f.documents[d] || {};
    if (d === "NOA / Factoring Letter" && r.status === "N/A" && !usesFactoring) continue;
    if (r.status !== "Verified") return `${d} must be Verified${d.startsWith("NOA") ? (usesFactoring ? " for factored carriers" : " or marked N/A") : ""}.`;
    if (EXPIRY_DOCS.includes(d) && (!r.expiry || r.expiry <= today())) return `${d} needs a future expiry date.`;
  }
  return "";
};

const risk = (f) => {
  const v = riskVerdict(f);
  if (v === "Failed") return "A critical red flag is checked. Reject this carrier from Lead Management.";
  if (!f.risk_score) return "Set a risk score.";
  if (v === "Passed with Notes" && !f.risk_notes.trim()) return "Risk notes are required when flags are raised or the score is above 6.";
  return "";
};

const banking = (f) => {
  if (f.auto_debit_enabled === null) return "Choose whether auto debit is enabled.";
  if (f.auto_debit_enabled && (!f.auto_debit_method || !f.auto_debit_day || !f.auto_debit_auth_url)) return "Auto debit needs a method, a day and a signed authorization.";
  if (f.auto_debit_enabled === false && !f.no_auto_debit_reason.trim()) return "Explain why auto debit is not enabled.";
  if (f.factoring.bank_verified !== true) return "Bank details must be verified against the voided check.";
  return "";
};

const commercial = (f) => {
  const c = f.commercial;
  if (!c.plan.trim()) return "Confirm the dispatch plan.";
  if (!c.equipment.trim()) return "Confirm the equipment.";
  if (!c.lanes.trim()) return "Enter the preferred lanes.";
  return "";
};

const dispatcher = (f) => (f.dispatcher_id ? "" : "Assign a dispatcher.");
const signoff = (f) => (f.signoff_name.trim().length < 3 ? "Type your full legal name." : !f.attestation ? "Tick the attestation." : "");

export const STEP_VALIDATORS = { fmcsa, documents, risk, banking, commercial, dispatcher, signoff };

export const docsSatisfied = (f) => REQUIRED_DOCS.filter((d) => f.documents[d]?.status === "Verified" || (d.startsWith("NOA") && f.documents[d]?.status === "N/A" && f.factoring.uses_factoring !== true)).length;
